/**
 * Module « panier » (guichet) — vente téléphonique (BOU-11 à BOU-13).
 *
 * Deux écrans, montés sous `/admin/paniers` par le routeur de la fondation
 * (ARCHITECTURE §11) :
 *
 *   /admin/paniers          composer et conclure une vente téléphonique
 *   /admin/paniers/ouverts  BOU-13 — retrouver un panier à reprendre
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'

const PagePanierGuichet = lazy(() =>
  import('./PagePanierGuichet').then((m) => ({ default: m.PagePanierGuichet })),
)
const PagePaniersOuverts = lazy(() =>
  import('./PagePaniersOuverts').then((m) => ({ default: m.PagePaniersOuverts })),
)

export const routesPanier: RouteObject[] = [
  { index: true, element: <PagePanierGuichet /> },
  { path: 'ouverts', element: <PagePaniersOuverts /> },
]

export { PagePanierGuichet, PagePaniersOuverts }
